export default {
  'reports.title': 'Reports',
  'reports.manageReports.title': 'Manage Reports',
  'reports.manageGroups.title': 'Configure Report Group',
  'reports.tab.groups': 'Groups',
  'reports.tab.favorites': 'Favorites',

  'reports.manageGroups.components.powerBIServerConfigurationId': 'Power BI Server Configuration',
  'reports.manageGroups.components.powerBIReportGroupId': 'Power BI Report Group ID',
  'reports.manageGroups.components.powerBIReportId': 'Power BI Report ID',
  'reports.manageGroups.components.menuTitle': 'Menu Title',
  'reports.manageGroups.components.textHelp': 'Menu Help Text',
  'reports.manageGroups.components.asLink': 'Show as Link',

  'reports.manageReports.components.report-group': 'Report Group',
  'reports.manageReports.components.tagLink': 'Report Classification Tags',
  'reports.manageReports.components.multiplePages': 'Multiple Pages?',
  'reports.manageReports.components.defaultReport': 'Default Report Section',
  'reports.manageReports.components.enableDataFilter': 'Enable Report Data Filter by User?',
  'reports.manageReports.components.reportFilter': 'Enable Report Data Filter by User?',

  'reports.manageReports.components.reportId': 'Power BI Report ID',
  'reports.manageReports.components.datasetId': 'Power BI Dataset ID',
  'reports.manageReports.components.defaultReportSection': 'Default Report Section',
  'reports.manageReports.components.isMultipage': 'Multiple Pages?',
  'reports.manageReports.components.isReportDataFilterByUserEnabled':
    'Enable Report Data Filter by User?',
  'reports.manageReports.components.isReportDataFilterByPositionEnabled':
    'Filter Report Data by Position?',
  'reports.platform': 'Platform',

  'reports.manageReports.components.reportDataFilterUserTableName': 'Table Name for User Filter',
  'reports.manageReports.components.reportDataFilterUserFieldName': 'Field Name for User Filter',
  'reports.manageReports.components.reportDataFilterUserFieldNameInternal':
    'Internal Field Name for User Filter',
  'reports.manageReports.components.reportDataFilterPositionTableName':
    'Table Name for Position Filter',
  'reports.manageReports.components.reportDataFilterPositionFieldName':
    'Field Name for Position Filter',
  'reports.manageReports.components.reportDataFilterPositionFieldNameInternal':
    'Internal Field Name for Position Filter',
  'reports.operador.or': 'Or',
  'reports.operador.and': 'And',
  'reports.permissionsFiltersLogicalOperator': 'Logical Operator Permissions',
};
